import { render, staticRenderFns } from "./CardTicketMedio.vue?vue&type=template&id=227d7dea&"
import script from "./CardTicketMedio.vue?vue&type=script&lang=js&"
export * from "./CardTicketMedio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports